<template>
	<section>
		
		<!--列表-->
		<el-row v-for="item in datalist">
			<el-col :span="16" class="toolbar" style="padding-bottom: 0px;">
				<el-card shadow="hover">
					<el-descriptions :column="2" border>
						<el-descriptions-item label="学习者"> {{item.name}}</el-descriptions-item>
						<el-descriptions-item label="已学天数">{{item.stday}}</el-descriptions-item>
						<el-descriptions-item label="已学">{{item.stwords}}</el-descriptions-item>
						<el-descriptions-item label="掌握">{{item.stokwords}}</el-descriptions-item>
						<el-descriptions-item label="今日学习" v-if="item.todayFlag=='1'" :span="2">
							<el-button type="primary" @click.native="addItem(item)" icon="el-icon-circle-plus-outline" size="mini"></el-button><br/>
							<el-table :data="item.todaySt" border stripe highlight-current-row style="width:90%;">
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<div>
											<el-button v-if="scope.row.status!='0'" type="text" size="small" @click="uptStatus(scope.row.id,'0')">NoOk</el-button>
											<el-button v-if="scope.row.status!='1'" type="text" size="small" @click="uptStatus(scope.row.id,'1')">掌握</el-button><br/>
											<el-button v-if="scope.row.status!='2'" type="text" size="small" @click="uptStatus(scope.row.id,'2')" icon="el-icon-check">首次OK</i>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="words" label="单词" min-width="300">
									<template slot-scope="scope">
										{{scope.$index}}.
										<font size="4" v-if="scope.row.status=='1'" color="green">
											{{scope.row.words}}
										</font>
										<font size="4" v-else-if="scope.row.status=='2'" color="green">
											{{scope.row.words}}<i class="el-icon-check"></i>
										</font>
										<font size="5" v-else color="red">
											{{scope.row.words}}
										</font>
										 [{{scope.row.yb}}] <br/>
										<div style="white-space: pre-wrap"> {{scope.row.wcn}}<div>
									</template>
								</el-table-column>
							</el-table>
						</el-descriptions-item>
						<el-descriptions-item label="今日学习" v-else :span="2">
							今日还未学习   <el-button type="primary" round @click.native="goStudy(item)">立刻学习</el-button>
						</el-descriptions-item>
						<el-descriptions-item label="未掌握" :span="2">
							<el-table :data="item.nookSt" border stripe highlight-current-row style="width:90%;">
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<div>
											<el-button v-if="scope.row.status=='1'" type="text" size="small" @click="uptStatus(scope.row.id,'0')">未掌握</el-button>
											<el-button v-else type="text" size="small" @click="uptStatus(scope.row.id,'1')">掌握</el-button>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="words" label="单词" min-width="300">
									<template slot-scope="scope">
										{{scope.$index}}.
										<font size="4" v-if="scope.row.status=='1'" color="green">
											{{scope.row.words}}
										</font>
										<font size="5" v-else color="red">
											{{scope.row.words}}
										</font>
									    [{{scope.row.yb}}] <br/>
										<div style="white-space: pre-wrap"> {{scope.row.wcn}}<div>
									</template>
								</el-table-column>
							</el-table>
						</el-descriptions-item>
						<el-descriptions-item label="需复习" :span="2">
							<el-table :data="item.fxSt" border stripe highlight-current-row style="width:90%;">
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<div>
											<el-button v-if="scope.row.status=='1'" type="text" size="small" @click="uptStatus(scope.row.id,'0')">未掌握</el-button>
											<el-button v-else-if="scope.row.status=='2'" type="text" size="small" @click="uptStatus(scope.row.id,'0')">未掌握</el-button>
											<el-button v-else type="text" size="small" @click="uptStatus(scope.row.id,'1')">掌握</el-button>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="words" label="单词" min-width="300">
									<template slot-scope="scope">
										{{scope.$index}}.
										<font size="4" v-if="scope.row.status=='1'" color="green">
											{{scope.row.words}}
										</font>
										<font size="4" v-else-if="scope.row.status=='2'" color="green">
											{{scope.row.words}}<i class="el-icon-check"></i>
										</font>
										<font size="5" v-else color="red">
											{{scope.row.words}}
										</font>
									    [{{scope.row.yb}}] <br/>
										<div style="white-space: pre-wrap"> {{scope.row.wcn}}<div>
									</template>
								</el-table-column>
							</el-table>
						</el-descriptions-item>
					</el-descriptions>
					
				</el-card>
			</el-col>
		</el-row>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="editFormVisible" :before-close="clickClose"
		  size="90%" :with-header="false"
		  direction="rtl">
			<!--编辑界面-->
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm" label-width="180px">
				<el-form-item :label="editformtitle">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
				</el-form-item>
				<el-form-item label="单词" prop="words">
					<el-input v-model="editForm.words" placeholder="单词" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="音标" prop="yb">
					<el-input v-model="editForm.yb" placeholder="音标" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="中文" prop="wcn">
					<el-input type="textarea" v-model="editForm.wcn" placeholder="中文" style="width:200px" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
				</el-form-item>
			</el-form>
		</el-drawer>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					p_id:'',shop_id:'',s_p_id:''
				},
				datalist: [],
				dcData:{},
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					words :[
						{required: true,message: '单词不能为空!',trigger: 'blur'}
					],
					wcn :[
						{required: true,message: '中文内容不能为空!',trigger: 'blur'}
					]
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',name_id:'',st_card_id:'',words:'',wcn:'',yb:''
				}
			}
		},
		methods: {
			checkTdStudy:function(queryNameId){
				let keyStr = 'td_' + queryNameId;
				if(this.dcData.hasOwnProperty(keyStr)){
					return true ;
				}
				return false ;
			},
			getFxList(queryNameId){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'ie60qrvQ.tbl_eng.ie60qrvQ.tbl_st_eng.fxquery',
				};
				para.name_id = queryNameId ;
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						//for (let key in res.data.datas) {
						//	if(res.data.datas['days']==0){
						//		let keyStr = 'td_' + queryNameId ; //今日数据
						//		this.dcData[keyStr] = res.data.datas['id'];//设置ID
						//	}else{
						//		let keyStr = 'fx_' + queryNameId ; //复习数据
						//		this.dcData[keyStr] = res.data.datas['id'];//设置ID
						//	}
						//}
					}
				});
				
			},
			getLists:function(){
				let para = {
					actionurl:'study/list',
					sqlid:'ie60qrvQ.tbl_eng.ie60qrvQ.tbl_st_name.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
						////////////循环表
						//for (let key in this.datalist) {
						//	let nameId = this.datalist[key].id;
						//	this.getFxList(nameId);
						//}
					}
					this.listLoading = false;
				});
			},
			goStudy:function(row){
				//立刻学习
				//console.log(">>"+row.id);
				let para = {
					name_id:row.id,
					actionurl:'study/addCard',
					sqlid:'testAdd'
				};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.$message({message: res.data.message,type: res.data.type});
						if(res.data.code==200){
							this.getLists();
						}
					}
				});
			},
			uptStatus:function(uptId,uptStatus){
				let para = {
					actionurl:'default/save',
					sqlid:'uu8cqba1.tbl_st_eng_dc.uptStatus',
					id:uptId,
					status:uptStatus
				};
				delData(para).then((res) => {
					this.listLoading = false;
					this.$message({message: res.data.message,type: res.data.type});
					this.getLists();
				});
			},
			addItem:function(row){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'uu8cqba1.tbl_st_eng_dc.add',
					name_id:row.id,st_card_id:row.card_id,words:'',wcn:'',yb:''
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'dyshop_shop_pdt.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveNotipFunction(this,para);
			},
			clickClose:function(){
				
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'dyshop_shop_pdt.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// dclist.vue?1110108c